import { useEffect } from 'react';
import { usePageTitle as usePageTitleContext } from './PageTitleContext';

export const usePageTitle = (title: string) => {
  const { setTitle } = usePageTitleContext();

  useEffect(() => {
    setTitle(title);
  }, [title]); // Remove setTitle from dependencies
}; 